import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
const createNamespaceContext = (namespace, displayName = 'NamespacedContext') => {
  const Component = props => {
    const newData = {
      [namespace]: props.data
    };
    return /*#__PURE__*/React.createElement(AnalyticsContext, {
      data: newData
    }, React.Children.only(props.children));
  };
  Component.displayName = displayName;
  return Component;
};
export default createNamespaceContext;